import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, Container, Divider, Grid, Paper, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import t1 from '../../assets/images/t10.png';
import s1 from '../../assets/images/s2.png';
import s2 from '../../assets/images/s7.png';

import icon_list from '../../assets/images/icon_list.png';
import icon_searcher from '../../assets/images/icon_searcher.png';
import icon_vcard from '../../assets/images/icon_vcard.png';
import icon_landingpage from '../../assets/images/icon_landingpage.png';
import o1 from '../../assets/images/website/marketplace.jpg';


import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ContactUs from "./contactUs";
import ContactUs2 from "./contactUs2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown, faArrowAltCircleDown, faArrowCircleDown, faArrowCircleRight, faArrowDown, faArrowRight, faArrowUpRightFromSquare, faCartShopping, faCheck, faCheckSquare, faCircleArrowDown, faCircleDown, faCogs, faMagic, faRocket, faStar, faTicket, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

//images
import imagen1 from '../../assets/images/site/forbusiness/imagen1.jpg';
import imagen2 from '../../assets/images/site/forbusiness/imagen2.jpg';
import imagen3 from '../../assets/images/site/forbusiness/imagen3.jpg';
import imagen4 from '../../assets/images/site/forbusiness/imagen4.jpg';
import imagen6 from '../../assets/images/site/forbusiness/imagen6.jpg';
import imagen7 from '../../assets/images/site/forbusiness/imagen7.jpg';
import imagen8 from '../../assets/images/site/forbusiness/imagen8.jpg';

import CheckList from "../../components/checkList";
import Service from "../../components/Service";

export default function ForBusiness()
{
    const {t, i18n} = useTranslation();
    const history = useHistory();
    const theme = useTheme();


    const redirect = (route) => {
        history.push(route);
    }

    const presencia = [
        {
            title:{es:'Catálogo digital',en:'Digital catalogue/Menu'},
            description:
            {
                es:'Crea un catálogo online de tus productos o servicios para que tus clientes puedan acceder a él desde cualquier lugar y en cualquier momento.',
                en:'Create an online catalogue of your products or services so that your customers can access it from anywhere and at any time.'
            }
        },
        {
            title:{es:'Marketplace',en:'Marketplace'},
            description:
            {
                es:'Vende tus productos online a través de nuestro marketplace integrado, con pasarelas de pago nacionales e internacionales.',
                en:'Sell your products online through our integrated marketplace, with national and international payment gateways.'
            }
        },
        {
            title:{es:'Sistema de reseñas',en:'Reviews'},
            description:
            {
                es:'Permite que tus clientes dejen reseñas sobre tus productos o servicios, lo que te ayudará a generar confianza y aumentar tus ventas.',
                en:'Allow your customers to leave reviews about your products or services, which will help you build trust and increase your sales.'
            }
        },
        {
            title:{es:'Sistema de cupones',en:'Coupons'},
            description:
            {
                es:'Ofrece cupones y descuentos a tus clientes para fidelizarlos y aumentar tus ventas.',
                en:'Offer coupons and discounts to your customers to build loyalty and increase your sales.'
            }
        },
    ];

    const ventajas = [
        {
            src:icon_searcher,
            title:{es:'Listado de comercios',en:'Search engines'},
            description:
            {
                es:'Aparecerás en los buscadores y en el listado de comercios aliados de Anzoátegui Te Enamora',
                en:'You will appear in search engines and in the list of Anzoátegui Te Enamora partner businesses.'
            }
        },
        {
            src:icon_vcard,
            title:{es:'Tarjetas de presentación',en:'E-Business cards'},
            description:
            {
                es:'Podrás emitir tarjetas de presentación virtuales para ti y tu equipo',
                en:'You will be able to issue virtual business cards for yourself and your team'
            }
        },
        {
            src:icon_landingpage,
            title:{es:'Visibilidad',en:'Landing page'},
            description:
            {
                es:'Podrás mostrar información relevante de tu negocio a clientes potenciales',
                en:'You will be able to show relevant information about your business to potential customers'
            }
        },
    ];

    const gestion = [
        {
            title:{es:'Gestión de pedidos',en:'Order management'},
            description:
            {
                es:'Recibe y gestiona tus pedidos online de forma eficiente.',
                en:'Receive and manage your online orders efficiently.'
            }
        },
        {
            title:{es:'Gestión de clientes',en:'Customer Management'},
            description:
            {
                es:'Mantén una base de datos actualizada de tus clientes y segmenta tus envíos de email marketing.',
                en:'Keep an updated database of your customers and segment your email marketing campaigns.'
            }
        },
        {
            title:{es:'Gestión de eventos',en:'Event management'},
            description:
            {
                es:'Crea, organiza y promociona tus eventos online o presenciales.',
                en:'Create, organize and promote your online or in-person events.'
            }
        },
    ];

     /**
     *  title:{es:'',en:''},
        description:
        {
            es:'',
            en:''
        }
     */


    const princing = [{
        benefits:{
            es:[
                'Acceso completo a todos los servicios base',
                'Inducción y capacitación inicial',
                'Acceso a futuras actualizaciones',
                'Posibilidad de añadir servicios de pago por uso',
                'Análisis de datos',
                'Soporte técnico',
            ],
            en:[
                'Full access to all core services',
                'Initial onboarding & training',
                'Free future updates',
                'Ability to add on-demand services',
                'Data analytics',
                'Technical support',
            ] 
        },
        plans:{

        }
    }];
        /*{
            plan:'Business',
            anualPrice: 18.00,
            monthlyPrice:23.00,
            benefits:[
                '+ Starter',
                'Analítica de productos',
                'Analítica de reseñas',
                'Gestión de reservaciones',
                'Email marketing',
            ]
        }*/

    const plansProperties = [
        {es:'Acceso completo a todos los servicios base',en:'Full access to all core services'},
        {es:'Inducción y capacitación inicial',en:'Initial onboarding & training'},
        {es:'Acceso a futuras actualizaciones',en:'Free future updates'},
        {es:'Posibilidad de añadir servicios de pago por uso',en:'Ability to add on-demand services'},
        {es:'Análisis de datos',en:'Data analytics'},
        {es:'Soporte técnico',en:'Technical support'},
    ];

    const section2 = [
        {
            icon: faWandMagicSparkles,
            title:{es:'Interfaz Intuitiva y Amigable',en:'Intuitive and User-Friendly Interface'},
            description:{
                es:'Navega y gestiona todo de forma natural, gracias a un diseño limpio y fácil de entender',
                en:'Navigate and manage everything naturally, thanks to a clean and easy-to-understand design'
            }
        },
        {
            icon: faCheck,
            title:{es:'Cero Conocimientos Técnicos',en:'No Tech Skills Needed'},
            description:{
                es:'Olvídate de códigos o configuraciones complejas. Si sabes usar tus redes sociales, sabes usar Anzoátegui Te Enamora',
                en:`Forget about complex code or configurations. If you can handle social media, you're ready for Anzoátegui Te Enamora`
            }
        },
        {
            icon: faRocket,
            title:{es:'Lanza tu Proyecto en Minutos',en:'Go Live in minutes'},
            description:{
                es:'Configura tu presencia online, tu catálogo de productos o tu evento en tiempo récord',
                en:'Set up your online presence, product catalog, or event in record time and be ready to welcome customers right away.'
            }
        },
    ];

    const section3 = [
        {
            icon: faCogs,
            title:{es:'Herramientas de Gestión',en:'Management Tools'},
            description:{
                es:'Controla tus pedidos, clientes y eventos desde un solo lugar, con herramientas diseñadas para facilitarte la vida',
                en:'Manage your orders, customers, and events from one place, with tools designed to make your life easier'
            }
        }
    ];

    return(
        <Box>
            <Container maxWidth='xl' sx={{paddingTop:{xs:20,lg:20}}}>
                <Grid container spacing={3} alignItems={'center'}>

                    <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                                    {t('forBusiness.section1.titleLine1')}
                                </Typography>
                                <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'} gutterBottom>
                                    {t('forBusiness.section1.titleLine2')}
                                </Typography>
                                <Typography variant='h6' component={'p'} color={'#5A5A5A'} gutterBottom >
                                    { t('forBusiness.section1.description')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                                <Button variant='contained' style={{borderRadius:30}} onClick={()=>redirect('/auth/merchantSignUp')}>
                                    <Typography variant='h6'>
                                        &nbsp;&nbsp;{t('helpers.getStarted')}&nbsp;&nbsp;
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <Button variant='text' sx={{borderRadius:30,color:'link.main'}} onClick={()=>redirect('/merchants/services')}>
                                    <Typography variant='h6'>
                                        &nbsp;&nbsp;{t('forBusiness.explore')}&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{color:'#147ac2'}}/>
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                        

                    </Grid>
                    
                    <Grid item xs={12} sm={12} md={6} lg={7} xl={7}>
                        <motion.div
                                initial={{ opacity: 0,translateY:200 }}
                                whileInView={{ opacity: 1,translateY:0 }}
                                viewport={{ once: false }}
                            >
                                <img
                                    src={imagen1}
                                    alt='qud'
                                    style={{width:'100%',borderRadius:50}}
                                />
                        </motion.div>
                    </Grid>
                </Grid>
            </Container>

            {/**Franja de banner de texto */}
            <Box sx={{bgcolor:'primary.main',mt:7,mb:7}}>
                <Grid container>
                    <Grid item xs={12} md={12} lg={3} mt={5} mb={5}>
                        <Typography variant="h6" fontWeight={'bold'} textAlign={'center'} color={'primary.contrastText'}>
                            Emprendedores
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} lg={3} mt={5} mb={5}>
                        <Typography variant="h6" fontWeight={'bold'} textAlign={'center'} color={'primary.contrastText'}>
                            Comercios
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} lg={3} mt={5} mb={5}>
                        <Typography variant="h6" fontWeight={'bold'} textAlign={'center'} color={'primary.contrastText'}>
                            Profesionales
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} lg={3} mt={5} mb={5}>
                        <Typography variant="h6" fontWeight={'bold'} textAlign={'center'} color={'primary.contrastText'}>
                            Empresas
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            <Container maxWidth='xl' sx={{paddingTop:{xs:20,lg:10}}}>
                <Grid container spacing={3} alignItems={'center'}>
                    <Grid item xs={12} sm={12} md={6} lg={7} xl={7}>
                        <motion.div
                            initial={{ opacity: 0,translateY:200 }}
                            whileInView={{ opacity: 1,translateY:0 }}
                            viewport={{ once: false }}
                        >
                            <img
                                src={imagen6}
                                alt='qud'
                                style={{width:'90%',borderRadius:50}}
                            />
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                        <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                            {t('forBusiness.section2.titleLine1')}
                        </Typography>

                        <Typography variant='h6' component={'p'} color={'#5A5A5A'} gutterBottom >
                            {t('forBusiness.section2.description')}
                        </Typography>

                        {
                            section2.map((item,index)=>
                                <Box sx={{mt:5}}>
                                    <Grid container spacing={3} alignItems={'center'}>
                                        <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                                            <Avatar sx={{ bgcolor: '#ebeef6', width: 80, height: 80 }}>
                                                <FontAwesomeIcon icon={item.icon} color={'#147ac2'} style={{fontSize:30}}/>
                                            </Avatar>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3} lg={10} xl={10}>
                                            <Typography variant='h6' component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                                                {i18n.language === 'es' ? item.title.es : item.title.en}
                                            </Typography>
                                            <Typography variant='h6' component={'h1'} color={'#5A5A5A'}>
                                                {i18n.language === 'es' ? item.description.es : item.description.en}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )
                        }
                        
                    </Grid>
                </Grid>
            </Container>


            {/**Section 3 */}
            <Box sx={{bgcolor:'#f8f8f9',mt:7,mb:7,pb:10}}>
                <Container maxWidth='xl'>
                    <Grid container spacing={3} alignItems={'center'}>
                        <Grid item xs={12} md={12} lg={12} xl={12} mt={5} mb={5}>
                            <Typography variant="h4" component={'h1'} fontSize={45} fontWeight={'bold'} textAlign={'center'} color={'primary.main'}>
                                {t('forBusiness.section3.titleLine1')}
                            </Typography>
                            <Typography variant="h6" component={'p'} fontWeight={'bold'} textAlign={'center'} color={'#5A5A5A'}>
                                {t('forBusiness.section3.descriptionLine1')}
                            </Typography>
                            <Typography variant="h6" component={'p'} fontWeight={'bold'} textAlign={'center'} color={'#5A5A5A'}>
                                {t('forBusiness.section3.descriptionLine2')}
                            </Typography>
                        </Grid>

                        {/**Column 1 */}
                        <Grid item lg={4} xl={4}>
                            <Grid container spacing={3}>
                                {/**Gestion de Eventos */}
                                <Service
                                    icon={faTicket}
                                    title={ i18n.language === 'es' ? 'Gestión de Eventos' : 'Event Management'}
                                    description={ 
                                        i18n.language === 'es' 
                                        ? 'Vende entradas, controla el acceso y gestiona a tus asistentes de forma profesional y sin complicaciones' 
                                        : 'Seamlessly sell tickets, control access, and manage attendees for a professional, hassle-free event experience'
                                    }
                                />

                                {/**Sistema de Resenas */}
                                <Service
                                    icon={faStar}
                                    title={ i18n.language === 'es' ? 'Sistema de Reseñas' : 'Customer Reviews'}
                                    description={ 
                                        i18n.language === 'es' 
                                        ? 'Construye confianza y mejora tu reputación recopilando y mostrando las valiosas opiniones de tus clientes' 
                                        : 'Build trust and enhance your reputation by collecting and showcasing valuable feedback from your customers'
                                    }
                                />
                                
                            </Grid>
                        </Grid>

                        {/**Column 2 */}
                        <Grid item lg={4} xl={4}>
                            <motion.div
                                initial={{ opacity: 0,translateY:200 }}
                                whileInView={{ opacity: 1,translateY:0 }}
                                viewport={{ once: false }}
                            >
                                <img
                                    src={imagen8}
                                    alt='qud'
                                    style={{width:'100%',borderRadius:40}}
                                />
                            </motion.div>
                        </Grid>

                        {/**Column 3 */}
                        <Grid item lg={4} xl={4}>
                            <Grid container spacing={3}>
                                {/**Landing page */}
                                <Service
                                    icon={faRocket}
                                    title={ i18n.language === 'es' ? 'Landing Pages' : 'Landing Pages'}
                                    description={ 
                                        i18n.language === 'es' 
                                        ? `Crea una página de presentación profesional para tu negocio o evento en minutos` 
                                        : `Launch a professional landing page for your business or event in minutes \n\n\n`
                                    }
                                />

                                {/**Menu */}
                                <Service
                                    icon={faCartShopping}
                                    title={ i18n.language === 'es' ? 'Catálogo Digital' : 'Digital Catalogue/Menu'}
                                    description={ 
                                        i18n.language === 'es' 
                                        ? 'Muestra tus productos, servicios o menú de forma atractiva y organizada a tus clientes'
                                        : `Showcase your products, services, or menu in an attractive and organized catalog for your customers \n\n`
                                    }
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} md={12} lg={12} xl={12} mt={5} mb={5} alignItems={'center'}>
                            <Grid container spacing={3} justifyContent={'center'} alignItems={'center'}>
                                <Button variant='contained' style={{borderRadius:30}} onClick={()=>redirect('/auth/merchantSignUp')}>
                                    <Typography variant='h6'>
                                        &nbsp;&nbsp;{t('helpers.getStarted')}&nbsp;&nbsp;
                                    </Typography>
                                </Button>
                                <Button variant='text' sx={{borderRadius:30,color:'link.main',ml:5}} onClick={()=>redirect('/merchants/services')}>
                                    <Typography variant='h6'>
                                        &nbsp;&nbsp;{t('forBusiness.explore')}&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{color:'#147ac2'}}/>
                                    </Typography>
                                </Button>
                            </Grid>
                            
                        </Grid>
                    </Grid>
                </Container>
            </Box>


            {/**Section 4 - Pricing */}
            <Container maxWidth='xl' sx={{paddingTop:{xs:20,lg:10},pb:10}}>
                <Grid container spacing={3} alignItems={'center'} justifyContent={'space-between'}>

                    <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                        <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                            {t('forBusiness.pricing.titleLine1')}
                        </Typography>
                        <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                            {t('forBusiness.pricing.titleLine2')}
                        </Typography>

                        <Typography variant='h6' component={'p'} color={'#5A5A5A'} gutterBottom >
                            {t('forBusiness.pricing.description')}
                        </Typography>

                        {
                            plansProperties.map( item => 
                                <CheckList 
                                    title={ i18n.language === 'es' ? item.es : item.en }
                                />
                            )
                        }
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Paper elevation={1}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Typography variant="body1" fontWeight={'bold'}>
                                                {t('forBusiness.pricing.quarterly.title')}
                                            </Typography>
                                            <Typography variant="h3">
                                                $35.00<span style={{fontSize:25,fontWeight:'bold'}}>USD</span>
                                                <span style={{fontSize:25,textTransform:'lowercase'}}>/{t('helpers.mo')}</span>
                                            </Typography>
                                            <Typography variant='body1' component={'p'} color={'#5A5A5A'} gutterBottom >
                                                {t('forBusiness.pricing.quarterly.description')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Paper elevation={4} sx={{ border: '2px solid #147ac2' }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                             <Typography variant="body1" fontWeight={'bold'}>
                                                {t('forBusiness.pricing.semiAnnual.title')}
                                            </Typography>
                                            <Typography variant="h3">
                                                $28.00<span style={{fontSize:25,fontWeight:'bold'}}>USD</span>
                                                <span style={{fontSize:25,textTransform:'lowercase'}}>/{t('helpers.mo')}</span>
                                            </Typography>
                                            <Typography variant='body1' component={'p'} color={'#5A5A5A'} gutterBottom >
                                               {t('forBusiness.pricing.semiAnnual.description')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Paper elevation={1}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                             <Typography variant="body1" fontWeight={'bold'}>
                                                {t('forBusiness.pricing.annual.title')}
                                            </Typography>
                                            <Typography variant="h3">
                                                $24.00<span style={{fontSize:25,fontWeight:'bold'}}>USD</span>
                                                <span style={{fontSize:25,textTransform:'lowercase'}}>/{t('helpers.mo')}</span>
                                            </Typography>
                                            <Typography variant='body1' component={'p'} color={'#5A5A5A'} gutterBottom >
                                               {t('forBusiness.pricing.annual.description')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant='body1' component={'p'} color={'#5A5A5A'} gutterBottom >
                                    {t('forBusiness.pricing.note')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>



            {/**Presencia online 
            <Box>
                <Container maxWidth='lg' >
                    <Grid container spacing={3} alignItems={'center'}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'} gutterBottom>
                                {t('forBusiness.bootsOnline')}
                            </Typography>

                            <Box>
                                {
                                    presencia.map(item=>
                                        <Accordion elevation={0}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <Typography variant='h6' component={'h1'} fontWeight={'bold'} color={'primary.main'} gutterBottom >
                                                    {i18n.language==='es'?item.title.es:item.title.en}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography variant='h6' component={'p'} color={'#5A5A5A'} gutterBottom >
                                                    {i18n.language==='es'?item.description.es:item.description.en}
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>       
                                    ) 
                                }
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <motion.div
                                initial={{ opacity: 0,translateY:200 }}
                                whileInView={{ opacity: 1,translateY:0 }}
                                viewport={{ once: false }}
                            >
                                <img
                                    src={s1}
                                    alt='cupones'
                                    style={{width:'100%',borderRadius:50}}
                                />
                            </motion.div>
                        </Grid>

                    </Grid>
                </Container>
            </Box>*/}

            {/**Ventajas 
            <Box mt={10}>
                <Container maxWidth='xl'>
                    <Grid container spacing={3} justifyContent={'center'}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {
                                i18n.language === 'es'
                                ?
                                <Typography variant="h4" fontWeight={'bold'} textAlign={'center'}>
                                    Si ya tienes QUD<br/>
                                    puedes disponer de<br/> las siguientes
                                    ventajas
                                </Typography>
                                :
                                <Typography variant="h4" fontWeight={'bold'} textAlign={'center'}>
                                    If you already have<br/>
                                    a user in QUD<br/>
                                    you have the <br/>following advantages
                                </Typography>
                            }
                            
                        </Grid>
                            
                        {
                            ventajas.map(item =>
                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} display={'flex'} flexDirection={'column'} alignItems={'center'} mt={10}>
                                    <Paper elevation={6}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Box sx={{display:'flex',flexDirection:'row',justifyContent:'center',mt:-10}}>
                                                    <Box sx={{bgcolor:'primary.main',p:1,borderRadius:5}}>
                                                        <Avatar
                                                            variant="rounded"
                                                            alt="QUD"
                                                            src={item.src}
                                                            sx={{ width: 100, height: 100 }}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Typography variant="h5" fontWeight={'bold'} textAlign={'center'}>
                                                    {i18n.language === 'es' ? item.title.es : item.title.en}
                                                </Typography>
                                                <Typography pl={3} pr={3} variant='h6' component={'p'} color={'#5A5A5A'} gutterBottom mt={5} textAlign={'center'}>
                                                    {i18n.language === 'es' ? item.description.es : item.description.en}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            )
                        }
                        

                        

                    </Grid>
                </Container>
            </Box>*/}


            {/**Optimizar la gestión 
            <Box sx={{mt:15,mb:15}}>
                <Container maxWidth='lg' >
                    <Grid container spacing={3} alignItems={'center'}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <motion.div
                                    initial={{ opacity: 0,translateY:200 }}
                                    whileInView={{ opacity: 1,translateY:0 }}
                                    viewport={{ once: false }}
                                >
                                    <img
                                        src={s2}
                                        alt='cupones'
                                        style={{width:'100%',borderRadius:50}}
                                    />
                                </motion.div>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <Typography variant='h4' fontSize={45} component={'h1'} color={'primary.main'} fontWeight={'bold'} textAlign={'right'} gutterBottom>
                                {t('forBusiness.optimize')}
                            </Typography>
                            <Box>
                                {
                                    gestion.map(item=>
                                        <Accordion elevation={0}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <Typography variant='h6' component={'h1'} fontWeight={'bold'} color={'primary.main'} gutterBottom >
                                                    {i18n.language === 'es' ? item.title.es : item.title.en}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography variant='h6' component={'p'} color={'#5A5A5A'} gutterBottom >
                                                {i18n.language === 'es' ? item.description.es : item.description.en}
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>       
                                    ) 
                                }
                            </Box>
                        </Grid>

                        

                    </Grid>
                </Container>
            </Box>*/}


            {/** 
            <Box mt={5}>
                <Container maxWidth='lg'>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant='h5' component={'p'} color={'#5A5A5A'} gutterBottom textAlign={'center'}>
                                Todo esto, con una interfaz intuitiva y fácil de usar, a un precio accesible para empresas de todos los tamaños.
                            </Typography>
                            <Typography mt={5} variant='h5' component={'p'} color={'#5A5A5A'} gutterBottom textAlign={'center'}>
                                Con nuestras herramientas, puedes empezar a trabajar de inmediato sin necesidad de conocimientos técnicos.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>*/}

            {/**Pricing 
            <Box
                sx={{
                    mb:10,
                    position:'relative'
                }}
            >
                
                    <Container maxWidth='lg'>
                        <Grid container spacing={3} justifyContent={'center'}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography variant='h4' fontSize={45} fontWeight={'bold'} color='primary.main' textAlign={'center'}>
                                    {i18n.language === 'es' ? 'Nuestros Planes' : 'Our Membership Plans'}
                                </Typography>
                            </Grid>
                            {
                                princing.length !== 0 &&
                                princing.map(item =>
                                    <Grid item xs={12} lg={4} xl={4}>
                                        <Paper elevation={4} sx={{height:'100%'}}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Typography variant="h6" fontWeight={'bold'} color={'link.main'}>
                                                        {item.plan}
                                                    </Typography>
                                                    <Box sx={{display:'flex',flexDirection:'row'}}>
                                                        <Typography variant="h4" fontWeight={'bold'}>{item.anualPrice} $</Typography>
                                                        <Typography variant="h6" fontWeight={'bold'} ml={1}>/{t('helpers.month')}*</Typography>
                                                    </Box>
                                                    <Typography fontWeight={'bold'} color={'cancel.dark'} mb={1}>
                                                        *{t('helpers.anualBilling')}
                                                    </Typography>
                                                    <Typography fontWeight={'bold'} variant="body2">
                                                        {item.monthlyPrice} $ /{t('helpers.month')} {t('helpers.monthlyBilling')}
                                                    </Typography>
                                                    <Divider/>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Typography variant="body1" fontWeight={'bold'}>
                                                        {t('helpers.includes')}
                                                    </Typography>
                                                    {
                                                        i18n.language === 'es'
                                                        ?
                                                        item.benefits.es.map(benefit=>
                                                        <Box sx={{display:'flex',flexDirection:'row',alignItems:'center',mt:1}}>
                                                            <FontAwesomeIcon color={theme.palette.success.main} icon={faCheckSquare}/>
                                                            <Typography variant="body1" fontWeight={'bold'} ml={1}>{benefit}</Typography>
                                                        </Box>
                                                        )
                                                        :
                                                        item.benefits.en.map(benefit=>
                                                            <Box sx={{display:'flex',flexDirection:'row',alignItems:'center',mt:1}}>
                                                                <FontAwesomeIcon color={theme.palette.success.main} icon={faCheckSquare}/>
                                                                <Typography variant="body1" fontWeight={'bold'} ml={1}>{benefit}</Typography>
                                                            </Box>
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </Container>
            </Box>*/}

            {/**Contactanos */}
            <ContactUs2
                title={t('contactUs.title2')}
                description={t('contactUs.text')}
                buttonText={t('contactUs.buttonText')}
            />


        </Box>
    )
}